import React from "react";
import { Box, Typography, Grid, TextField, MenuItem, Paper } from "@mui/material";
import { Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";

const CertificateComponent = ({ externalEntities, control, errors }) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          نموذج التقديم
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={3} container>
        <Grid item xs={12} md={4}>
          <Typography sx={{ fontWeight: "bold" }}>الجهة الموجَّه إليها الكتاب</Typography>

          <Controller
            name="externalEntities"
            control={control}
            defaultValue=""
            rules={{
              required: "هذا الحقل مطلوب",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                fullWidth
                variant="outlined"
                value={field.value || ""}
                FormHelperTextProps={{
                  sx: {
                    textAlign: "start",
                  },
                }}
                error={!!errors.externalEntities}
                helperText={
                  errors.externalEntities ? errors.externalEntities.message : ""
                }
              >
                {externalEntities.map((option) => (
                  <MenuItem key={option.name} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
      </Grid>
      </Paper>
    </>
  );
};

export default CertificateComponent;
